document.addEventListener("DOMContentLoaded", function () {

  // OPEN POPUP
  document.querySelectorAll('.open-popup').forEach(function(btn) {
    btn.addEventListener('click', function() {
      let id = this.getAttribute('data-target');
      let popup = document.getElementById(id);
      if (popup) {
        popup.style.display = 'block';
      }
    });
  });

  // CLOSE BUTTON CLICK
  document.querySelectorAll('.close').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.popup').forEach(function(popup) {
        popup.style.display = 'none';
      });
    });
  });

  // CLICK OUTSIDE (OVERLAY)
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('popup')) {
      document.querySelectorAll('.popup').forEach(function(popup) {
        popup.style.display = 'none';
      });
    }
  });

});